import { render, staticRenderFns } from "./AI-compare-report.vue?vue&type=template&id=1a1046cf"
import script from "./AI-compare-report.vue?vue&type=script&lang=js"
export * from "./AI-compare-report.vue?vue&type=script&lang=js"
import style0 from "./AI-compare-report.vue?vue&type=style&index=0&id=1a1046cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports